module.exports = __webpack_public_path__ + "img/carmens_logo.bbcd9f4a.jpg";